import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { analytics } from "@/lib/analytics";

const ROUTE_NAMES: Record<string, string> = {
  "/": "Home",
  "/races": "Races",
  "/results": "Results",
  "/leagues": "Leagues",
  "/profile": "Profile",
  "/admin": "Admin",
  "/sign-in": "Sign In",
  "/sign-up": "Sign Up",
  "/onboarding": "Onboarding",
};

function getPageName(pathname: string): string {
  if (ROUTE_NAMES[pathname]) return ROUTE_NAMES[pathname];
  if (pathname.startsWith("/races/")) return "Race Detail";
  if (pathname.startsWith("/leagues/")) return "League Detail";
  if (pathname.startsWith("/join/")) return "Join League";
  return "Other";
}

export default function PageViewTracker() {
  const location = useLocation();
  useEffect(() => {
    analytics.pageView(getPageName(location.pathname), {
      path: location.pathname,
    });
  }, [location.pathname]);
  return null;
}
